import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ds-dropdown__item ds-dropdown__item--value" }
const _hoisted_2 = { class: "ds-dropdown__item-text" }
const _hoisted_3 = {
  key: 1,
  class: "ds-dropdown__placeholder"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "ds-dropdown__item-text" }

import { computed, ComputedRef, useAttrs } from "vue";
import Select from "primevue/select";
import DsIcon from "../../icon/ds-icon.vue";
import DsButton from "../../button/ds-button.vue";
import DsFormField, { DsFormFieldProps, stripFormFieldProps } from "./general/ds-form-field.vue";
import { DsFormFieldValueType } from "../models/ds-form-field-models";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";

import { getDropdownPtOptions } from "./ds-dropdown/ds-dropdown-pt";
import { DsDropdownItemModel } from "./ds-dropdown/ds-dropdown-models";

const virtualScrollerLimit = 50;

/**
 * Selected value of the dropdown.
 */

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ds-dropdown',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    label: {},
    tooltipText: {},
    supportingText: {},
    isError: { type: Boolean },
    errorMessage: {},
    floatingError: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean },
    theme: {},
    isInStorybook: { type: Boolean },
    options: {},
    dataTest: {},
    fallbackLabel: {},
    dataTestid: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const { class: wrapperClass, ...attrs } = useAttrs();

const modelValue = _useModel<DsFormFieldValueType>(__props, "modelValue");

const props = __props;
const wrapperProps = computed(() => stripFormFieldProps(props));

const isLg = useBreakpoints("lg");
const itemSize = computed(() => (!isLg.value ? 40 : 48));
const virtualScrollerOptions = computed(() =>
    props.options.length > virtualScrollerLimit ? { itemSize: itemSize.value } : undefined
);

const scrollHeight = computed(() => `${itemSize.value * 5}px`);

// slotValueProps doesn't have valid information about currentOption
const currentSelectedOption: ComputedRef<DsDropdownItemModel> = computed(() => {
    if (modelValue.value || modelValue.value == 0) {
        return props?.options.find((option) => option.value == modelValue.value);
    }

    if (props.fallbackLabel) {
        return {
            label: props.fallbackLabel,
            value: null,
        };
    }

    return null;
});

const isValid = computed(() => !props.errorMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsFormField, _mergeProps({
    class: ["ds-dropdown", _unref(wrapperClass)]
  }, wrapperProps.value), {
    default: _withCtx(({ class: inputClasses }) => [
      _createVNode(_unref(Select), _mergeProps({
        name: _ctx.id,
        disabled: _ctx.disabled,
        invalid: !isValid.value,
        options: _ctx.options,
        optionLabel: "label",
        optionValue: "value",
        optionDisabled: "disabled",
        "scroll-height": scrollHeight.value,
        pt: _unref(getDropdownPtOptions)(inputClasses, _ctx.dataTest, _ctx.dataTestid),
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
      }, attrs, { "virtual-scroller-options": virtualScrollerOptions.value }), {
        dropdownicon: _withCtx((dropdownIconProps) => [
          _createVNode(DsButton, {
            type: "text",
            size: "sm",
            class: _normalizeClass([dropdownIconProps.class, 'ds-dropdown__select-icon-button']),
            "icon-left": "chevron-down",
            "aria-hidden": "true",
            tabindex: "-1",
            "is-in-storybook": _ctx.isInStorybook
          }, null, 8, ["class", "is-in-storybook"])
        ]),
        value: _withCtx((slotValueProps) => [
          _createElementVNode("div", _hoisted_1, [
            (currentSelectedOption.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (currentSelectedOption.value.icon)
                    ? (_openBlock(), _createBlock(DsIcon, {
                        key: 0,
                        name: currentSelectedOption.value.icon,
                        class: "ds-dropdown__item-icon",
                        "is-in-storybook": _ctx.isInStorybook
                      }, null, 8, ["name", "is-in-storybook"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(currentSelectedOption.value.label), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(slotValueProps.placeholder), 1))
          ])
        ]),
        option: _withCtx((slotOptionProps) => [
          _createElementVNode("div", {
            class: "ds-dropdown__item ds-dropdown__item--option",
            disabled: slotOptionProps.option.disabled
          }, [
            (slotOptionProps.option.icon)
              ? (_openBlock(), _createBlock(DsIcon, {
                  key: 0,
                  name: slotOptionProps.option.icon,
                  class: "ds-dropdown__item-icon",
                  "is-in-storybook": _ctx.isInStorybook
                }, null, 8, ["name", "is-in-storybook"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_5, _toDisplayString(slotOptionProps.option.label), 1)
          ], 8, _hoisted_4)
        ]),
        _: 2
      }, 1040, ["name", "disabled", "invalid", "options", "scroll-height", "pt", "modelValue", "virtual-scroller-options"])
    ]),
    inputRight: _withCtx(() => _cache[1] || (_cache[1] = [])),
    _: 1
  }, 16, ["class"]))
}
}

})